export default {
  SET_CASHBOOK (state, cashBook) {
    state.cashBook = cashBook
  },
  REMOVE_RECORD (state, itemId) {
    const cashBookIndex = state.cashBook.findIndex((u) => u.id === itemId)
    state.cashBook.splice(cashBookIndex, 1)
  }
}
